import React, { useState } from "react";
import AddPaymentView from "./AddPaymentView";
import "./BillingView.css";

const BillingView = () => {
  const [methods, setMethods] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [billingHistory, setBillingHistory] = useState([]); // vendrá de GraphQL
  const [adding, setAdding] = useState(false);

  // Muestra el formulario de añadir método
  const handleStartAdd = () => {
    setAdding(true);
  };

  // Vuelve al listado de métodos
  const handleFinishAdd = () => {
    setAdding(false);
  };

  // Si estamos añadiendo, renderiza sólo el formulario
  if (adding) {
    return <AddPaymentView onBack={handleFinishAdd} />;
  }

  return (
    <div className="billing-container large">
      {/* === Section Header: Payment Methods === */}
      <div className="section-header">
        <h1>Payment Methods</h1>
        <hr />
      </div>

      <div className="payment-methods">
        {methods.length > 0 ? (
          methods.map((pm, idx) => (
            <div key={idx} className="pm-card large">
              <div className={`pm-logo ${pm.logoClass}`} />
              <div className="pm-details">
                <span className="pm-type">{pm.type}</span>
                <span className="pm-number">{pm.number}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="no-methods">No payment methods added.</div>
        )}

        <button
          className="add-method-btn large"
          onClick={handleStartAdd}
        >
          Add Payment Method
        </button>
      </div>

      {/* === Section Header: Billing History === */}
      <div className="section-header" style={{ marginTop: "3rem" }}>
        <h1>Billing history</h1>
        <hr />
      </div>

      <div className="history-container large">
        <div className="history-filter large">
          <label htmlFor="month-select">Filter by month</label>
          <select
            id="month-select"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            <option value="">Select an option</option>
            <option value="03">Mar 2025</option>
            <option value="02">Feb 2025</option>
            {/* …otras opciones */}
          </select>
        </div>

        <table className="history-table large">
          <thead>
            <tr>
              <th>Date</th>
              <th>Invoice ID</th>
              <th>Status</th>
              <th>Amount</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {billingHistory.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-history">
                  No billing history
                </td>
              </tr>
            ) : (
              billingHistory.map((row, i) => (
                <tr key={i}>
                  <td>{row.date}</td>
                  <td>{row.invoice}</td>
                  <td>{row.status}</td>
                  <td>{row.amount}</td>
                  <td>
                    <a href="#" className="action-link">
                      view
                    </a>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BillingView;
